import { Skeleton } from '@/components/ui/skeleton';

interface UnifiedSummarySkeletonProps {
  variant?: 'default' | 'compact';
}

export function UnifiedSummarySkeleton({ variant = 'default' }: UnifiedSummarySkeletonProps) {
  const isCompact = variant === 'compact';
  return (
    <div
      className={`flex flex-col gap-3 rounded-lg border bg-card shadow-sm ${
        isCompact ? 'p-4' : 'p-5'
      }`}
    >
      <div className="flex flex-col gap-1">
        <Skeleton className="h-3 w-24" />
        <div className="flex items-baseline gap-2">
          <Skeleton className={isCompact ? 'h-6 w-16' : 'h-8 w-24'} />
          <Skeleton className="h-4 w-32" />
        </div>
      </div>
      <Skeleton className="h-[18px] w-full rounded-full" />
      <div className="flex flex-wrap gap-x-4 gap-y-2">
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-4 w-28" />
        <Skeleton className="h-4 w-28" />
      </div>
    </div>
  );
}
